import { render, staticRenderFns } from "./analytics-all-club-customization.vue?vue&type=template&id=b4ed8b1a&scoped=true&"
import script from "./analytics-all-club-customization.vue?vue&type=script&lang=js&"
export * from "./analytics-all-club-customization.vue?vue&type=script&lang=js&"
import style0 from "./analytics-all-club-customization.vue?vue&type=style&index=0&id=b4ed8b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed8b1a",
  null
  
)

export default component.exports